import React, {useCallback, useRef} from 'react'
import {DragData} from '@common/drag-data'
import {AvatarBase} from './avatar-base'
import {AvatarProps} from './types'
import {useOnAvatarClick} from './use-on-avatar-click'
import {useGuestUserProxy, useUserProxy} from './use-user-proxy'

export const Avatar = ({
  userId,
  guestId,
  withUserInfo,
  ...props
}: AvatarProps) => {
  const ref = useRef<Element>(null)
  const user = useUserProxy(userId)
  const guest = useGuestUserProxy(guestId)
  const onDragStart = useCallback(
    (e: React.DragEvent<HTMLElement>) => {
      if (user) {
        DragData.set(e, {type: 'user', userId: user.userId})
      }
    },
    [user]
  )
  const {onClick} = useOnAvatarClick({
    userId,
    ref,
    withUserInfo
  })

  const proxy = guest || user
  return proxy ? (
    <AvatarBase
      {...props}
      ref={ref}
      user={proxy}
      onDragStart={onDragStart}
      onClick={onClick}
    />
  ) : null
}
